import { Address, PostAddress } from "./Address";

export interface ELVData
{
    iban             : string,
    bic              : string, 
    bankname         : string,
    accountHolderName: string,
    bankAddress         : Address,
    accountHolderAddress: Address
}

export interface PostELVData
{
    claimId          : string,
    iban             : string,
    bic              : string, 
    bankname         : string,
    accountHolderName: string,

    bankAddress: PostAddress | null,
    accountHolderAddress: PostAddress,

    uploadedFiles: FileUpload[]
}

export const enum FileType
{
    Undefined     = -1,
    Travel        =  0,
    Accommodation =  1
}

export interface FileUpload
{
    Type: FileType,
    File: File
}